/**
 * InviteTokenPage - Placeholder for tenant admin invitation flow
 * TODO: Implement full invitation acceptance UI
 */
import React from 'react';

export default function InviteTokenPage({ token, onComplete }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-bold text-slate-800 mb-4">Accept Invitation</h1>
        <p className="text-slate-600 mb-6">
          This feature is coming soon. Please contact support.
        </p>
        <p className="text-xs text-slate-400 mb-4">Token: {token}</p>
        <button
          onClick={() => window.location.href = '/'}
          className="w-full py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Return to Home
        </button>
      </div>
    </div>
  );
}
